import { useThemeContext } from "../../../../context/ThemeContext";

const CourseHeader = ({ course, onBack }) => {
  const { darkMode } = useThemeContext();
  return (
    <div
      className={`flex justify-between items-center mb-6 p-4 rounded-lg ${
        darkMode
          ? "bg-[#0D1117] border border-[#252525]"
          : "bg-white border border-[#E0E0E0]"
      }`}
    >
      <div>
        <h2
          className={`text-xl font-bold ${
            darkMode ? "text-white" : "text-[#A41E22]"
          }`}
        >
          {course.course_code} - {course.course_title}
        </h2>
        <p
          className={`text-sm ${darkMode ? "text-gray-400" : "text-gray-600"}`}
        >
          Section: {course.section} | Semester: {course.semester}
        </p>
      </div>
      <button
        className={`px-3 py-1 rounded text-sm ${
          darkMode
            ? "bg-[#252525] text-white hover:bg-[#383838]"
            : "bg-gray-200 text-gray-700 hover:bg-gray-300"
        } transition-colors`}
        onClick={onBack}
      >
        Back to Courses
      </button>
    </div>
  );
};

export default CourseHeader;
